import { useCallback } from 'react';

import useToggle from '@lyearn/core/hooks/useToggle';
import { Trans, useTranslation } from '@lyearn/i18n';
import { AlertTriangleFill } from '@lyearn/icons';
import { LinkButton, Stack, Typography } from '@lyearn/ui';
import usePagination from '@/hooks/usePagination';

import { useQuestionsParentContentsQuery } from '../../../../../../graphql/queries/generated/questionsParentContents';
import ImpactedContentModal from '../ImpactedContentModal';
import { CorrectOptionChangedInfoProps } from './types';

const CorrectOptionChangedInfo: React.FC<CorrectOptionChangedInfoProps> = (props) => {
  const { question, initialQuestion, onChange } = props;
  const { t } = useTranslation();

  const [showImpactedContentModal, { off, on }] = useToggle();

  //re move to a common hook
  const { isLoading, totalCount, fetchMore, data } = usePagination(
    useQuestionsParentContentsQuery,
    {
      filters: { questionIds: [question.id] },
    },
    { edgeKey: 'getQuestionsParentContents' },
  );

  const onRevert = useCallback(() => {
    onChange({ ...question, options: initialQuestion?.options });
  }, [initialQuestion?.options, onChange, question]);

  return (
    <Stack className="pl-16 pt-16 pr-20 pb-20 rounded-8 border border-border" direction="col">
      <AlertTriangleFill className="w-20 h-20" fillColorToken="icon-warning" />
      <Typography className="mt-12" color="text-text-paragraph" variant="body-short-02">
        <Trans i18nKey="QuizCreator:EditingInfo.CorrectOptionChangeImpact" />{' '}
        {isLoading ? null : (
          <LinkButton className="self-start inline -mt-2" onClick={on}>
            {t('Common:BulkExport.Item', { count: totalCount })}
          </LinkButton>
        )}
      </Typography>
      <LinkButton className="self-start mt-16" onClick={onRevert}>
        {t('Admin:RevertChanges')}
      </LinkButton>
      {showImpactedContentModal ? (
        <ImpactedContentModal
          fetchMore={fetchMore}
          parentContents={data}
          title={t('QuizCreator:EditingInfo.ImpactedContent')}
          onClose={off}
        />
      ) : null}
    </Stack>
  );
};

export default CorrectOptionChangedInfo;
